import { AxiosResponse } from 'axios';
import { ErrorHandler } from './error_handler';
import { toast } from 'react-toastify';
import { ENVIROMENT_TYPE } from '../../config/constants';
import { getCurrentEnviromentType } from '../../utils/axios/configutation';
type ToastOptions = {
  customSuccessMsg?: string;
  customPendingMsg?: string;
  customErrorMsg?: string;
  noSuccessMsg?: boolean;
  noPendingMsg?: boolean;
  noFailureMsg?: boolean;
};
export const FeedbackToastHandler = async (
  promise: Promise<AxiosResponse<any>>,
  toastOptions: ToastOptions = {},
) => {
  return await toast.promise(promise, {
    pending: toastOptions.noPendingMsg
      ? undefined
      : (toastOptions.customPendingMsg ?? 'Loading...'),
    success: toastOptions.noSuccessMsg
      ? undefined
      : (toastOptions.customSuccessMsg ?? 'Action completed with success!'),
    error: toastOptions.noFailureMsg
      ? undefined
      : (toastOptions.customErrorMsg ?? {
          render({ data }: any) {
            const { code, message } = ErrorHandler(data);
            return `Oops! ${message}. Error code ${code}`;
          },
        }),
  });
};
